import React, { useEffect, useState } from "react";
import { Container, List, InputFilter, Boxs } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import {
  MdVisibility,
  MdAdd,
  MdDelete,
  MdUpdate,
  MdLink,
  MdEdit,
} from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";
import { format } from "date-fns";
import copy from "copy-to-clipboard";
import ModalC from "../../../components/modal";
import { ButtonC, InputC } from "../../../components/simple";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Input, Modal, Spin } from "antd";
import { Message, ViewInput, Table, Card } from "../../../GlobalStyles";
import Status from "../../../components/status";
import CountUp from "react-countup";
const { confirm } = Modal;

export default function Companies() {
  const { user } = useAuth();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [page, setPage] = useState(0);
  const [companies, setCompanies] = useState([]);
  const [totalCompanies, setTotalCompanies] = useState(0);
  const [infosCompanies, setInfosCompanies] = useState({});
  const [visibleModalHandler, setVisibleModalHandler] = useState(false);
  const [company, setCompany] = useState({});
  const [status, setStatus] = useState("");
  const [razao_social, setRazao_social] = useState("");
  const [observation, setObservation] = useState("");

  useEffect(() => {
    if (user.type != "cliente") {
      navigate(-1);
    } else {
      if (user.restricted) {
        toast.warn("Área restrita para franqueados");
        navigate(-1);
      } else {
        listCompanies(page, filterSearch, status);
      }
    }
  }, [page, filterSearch, status]);

  async function listCompanies(page, search, status) {
    let url = `/companies?page=${page}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    await api
      .get(url)
      .then((response) => {
        setCompanies(response.data.companies);
        setTotalCompanies(response.data.totalCompanies);
        setInfosCompanies(response.data.infosTotalCompanies);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createCompany() {
    setIsLoadingModal(true);
    if (!razao_social) {
      toast.warn("Preencha a razão social");
    } else {
      await api
        .post(`/company`, {
          razao_social: razao_social,
          observation: observation,
        })
        .then((response) => {
          listCompanies(page, filterSearch, status);
          copy(`https://app.gurusegead.com.br/company/${response.data.id}`);
          toast.success(
            "Formulário criado e copiado com sucesso, envie seu cliente completar o cadastro"
          );
          navigate(`/company/${response.data.id}`);
          setVisibleModal(false);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function deleteCompany(id) {
    await api
      .delete(`/company/${id}`)
      .then(() => {
        toast.success("Formulário excluido com sucesso");

        listCompanies(page, filterSearch, status);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function handlerCompany() {
    setIsLoadingModal(true);
    if (observation) {
      await api
        .put(`/company-handler/${company.id}`, {
          observation: observation,
        })
        .then(() => {
          toast.success("Alteração solicitada com sucesso");

          listCompanies(page, filterSearch, status);
          setVisibleModalHandler(false);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    } else {
      toast.warn("Deixe uma observação para o cliente");
    }
    setIsLoadingModal(false);
  }
  return (
    <Container>
      <h1>Formulários</h1>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={totalCompanies} separator="." />
      </Card>
      <Boxs>
        <div
          style={{ background: "#46E961" }}
          className={status == "confirmado" ? "active" : ""}
          onClick={() => {
            if (status == "confirmado") {
              setStatus("");
            } else {
              setStatus("confirmado");
            }
          }}
        >
          <p>Confirmados {infosCompanies?.totalCompaniesConfirmed || 0}</p>
        </div>
        <div
          style={{ background: "#46ADE9" }}
          className={status == "aguardando" ? "active" : ""}
          onClick={() => {
            if (status == "aguardando") {
              setStatus("");
            } else {
              setStatus("aguardando");
            }
          }}
        >
          <p>Aguardando {infosCompanies?.totalCompaniesPedding || 0}</p>
        </div>
        <div
          style={{ background: "#FFBB45" }}
          className={status == "alteracao" ? "active" : ""}
          onClick={() => {
            if (status == "alteracao") {
              setStatus("");
            } else {
              setStatus("alteracao");
            }
          }}
        >
          <p>Em Alteração {infosCompanies?.totalCompaniesHandler || 0}</p>
        </div>
        <div
          style={{ background: "#9D9D9D" }}
          className={status == "exxpirado" ? "active" : ""}
          onClick={() => {
            if (status == "exxpirado") {
              setStatus("");
            } else {
              setStatus("exxpirado");
            }
          }}
        >
          <p>Expirados {infosCompanies?.totalCompaniesExpired || 0}</p>
        </div>
      </Boxs>
      <div className="filter">
        <ViewInput style={{ flex: 1, maxWidth: 350 }}>
          <p>Pesquisar</p>
          <Input.Search
            value={filter}
            onChange={(text) => {
              setFilter(text.target.value);
            }}
            placeholder="pesquisar"
            onSearch={(text) => {
              setFilterSearch(text);
              if (page) {
                setPage(0);
              } else {
                listCompanies(0, filterSearch);
              }
            }}
            allowClear
            onClear={() => {
              setFilterSearch("");
              if (page) {
                setPage(0);
              }
              setFilter("");
            }}
            enterButton
          />
        </ViewInput>
        <Button
          type="primary"
          style={{
            marginTop: 17,
            marginLeft: 50,
            borderRadius: 50,
            marginRight: 15,
          }}
          onClick={() => {
            setObservation("");
            setRazao_social("");
            setVisibleModal(true);
          }}
        >
          Novo Formulário
        </Button>
      </div>
      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          {companies.length == 0 ? (
            <Message>Nenhum contrato encontrado</Message>
          ) : (
            <Table>
              <thead>
                <tr>
                  <td>Razão Social</td>
                  <td>Status</td>
                  <td>Data de Criação</td>
                  <td>Ultima atualização</td>
                  <td style={{ width: 150 }}>Ações</td>
                </tr>
              </thead>
              <tbody>
                {companies.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td>{item.razao_social}</td>
                      <td>
                        <Status
                          status={item.status}
                          isPayment={false}
                          style={{
                            fontSize: 11,
                            height: 20,
                            paddingBottom: 2,
                          }}
                        />
                      </td>
                      <td>
                        {format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}
                      </td>
                      <td>
                        {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent:
                              item.status != "assinado"
                                ? "space-between"
                                : "space-evenly",
                          }}
                        >
                          <MdVisibility
                            color="#000"
                            size={20}
                            onClick={() => {
                              navigate(`/view-company/${item.id}`);
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          />
                          <MdLink
                            color="#000"
                            size={20}
                            onClick={() => {
                              copy(
                                `https://app.gurusegead.com.br/company/${item.id}`
                              );
                              toast.success(
                                "Link do formulário copiado com sucesso"
                              );
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          />
                          {(item.status == "aguardando" ||
                            item.status == "alteracao") && (
                            <MdEdit
                              color="#000"
                              size={20}
                              onClick={() => {
                                navigate(`/company/${item.id}`);
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          )}
                          {item.status != "assinado" && (
                            <MdDelete
                              color="#000"
                              size={20}
                              onClick={() => {
                                confirm({
                                  okText: "Confirmar",
                                  title: "Deseja excluir esse formulário?",
                                  icon: <ExclamationCircleFilled />,
                                  content: `Após confirmação, o formulário será excluido.`,
                                  onOk() {
                                    deleteCompany(item.id);
                                  },
                                  onCancel() {},
                                  cancelText: "Cancelar",
                                });
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          )}

                          {item.status == "confirmado" && (
                            <MdUpdate
                              color="#000"
                              size={20}
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setCompany(item);
                                setObservation("");
                                setVisibleModalHandler(true);
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </>
      )}
      <Modal
        title="Novo Formulário"
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={"CADASTRAR"}
        cancelText="FECHAR"
        onOk={() => {
          createCompany();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            paddingTop: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ViewInput>
            <p>Razão Social</p>
            <Input
              type="text"
              value={razao_social}
              placeholder="razão social"
              onChange={(text) => {
                setRazao_social(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput style={{ marginRight: 0 }}>
            <p>Observação</p>
            <Input.TextArea
              type="text"
              value={observation}
              placeholder="deixe aqui uma observação"
              onChange={(text) => {
                setObservation(text.target.value);
              }}
            />
          </ViewInput>
        </div>
      </Modal>
      <Modal
        title="Solicitar Correção"
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModalHandler}
        okText={"SALVAR"}
        cancelText="FECHAR"
        onOk={() => {
          handlerCompany();
        }}
        onCancel={() => {
          setVisibleModalHandler(false);
        }}
      >
        <h4 style={{ textAlign: "center", margin: "25px 0", fontSize: 15 }}>
          Digite o que você deseja solicitar de correção no Formulário
        </h4>
        <ViewInput style={{ marginRight: 0 }}>
          <p>Observação</p>
          <Input.TextArea
            type="text"
            value={observation}
            placeholder="deixe aqui uma observação"
            onChange={(text) => {
              setObservation(text.target.value);
            }}
          />
        </ViewInput>
      </Modal>
    </Container>
  );
}
